
$('ul.topMenu li a').on('click', function(event) {
    event.preventDefault();

    var ids = $(this).attr('href');

    // 👇 disable CSS smooth scroll via JS
    $('html').css('scroll-behavior', 'auto');

    $('html, body')
      .stop(true, true)
      .animate({
          scrollTop: $(ids).offset().top - 70
      }, 2000);
});


function VanillaCounter() {
      let elements = document.querySelectorAll('[data-vanilla-counter]');

      elements.forEach((i) => {
        let start = parseInt(i.getAttribute('data-start-at')) || 0;
        let end = parseInt(i.getAttribute('data-end-at')) || 0;
        let delay = parseInt(i.getAttribute('data-delay')) || 0;
        let time = parseInt(i.getAttribute('data-time')) || 1000;

        let counter = start;
        let stepTime = Math.abs(Math.floor(time / (end - start)));

        i.innerHTML = counter;

        setTimeout(() => {
          let interval = setInterval(() => {
            counter += end > start ? 1 : -1;
            i.innerHTML = counter;

            if (counter == end) {
              clearInterval(interval);
            }
          }, stepTime);
        }, delay);
      });
    }

    // SCROLL TRIGGER
    var triggered = false;

    $(window).on('scroll', function () {
      if (!$('.running-bar').length) return;
      var sectionTop = $('.running-bar').offset().top - 600;
      var scrollTop = $(window).scrollTop();

      if (scrollTop > sectionTop && !triggered) {
        triggered = true;

        // Progress bar animation
        $('.sec8_left_inner_row').each(function () {
          var value = $(this).attr('data-wdth');

          $(this)
            .find('.s8_progress_inr')
            .css('width', value + '%');
        });

        // Start counter
        VanillaCounter();
      }
    });
    

    /*ACCORDION*/
    $('.question_box .accordion').click(function () {
      var questionDiv = $(this);
      var answerDiv = $(this).next('.acdn_content');
      var idx = $('.acdn_content').index(answerDiv);

      $('.acdn_content').each(function (index, ansDiv) {
        if (index != idx && $(ansDiv).is(':visible')) {
          $(ansDiv).slideUp(500, function () {
            $(ansDiv).prev('.accordion').removeClass('accordion_open');
          });
        }
      });

      if (answerDiv.is(':visible')) {
        answerDiv.stop().slideUp(500, function () {
          questionDiv.removeClass('accordion_open');
        });
      } else {
        questionDiv.addClass('accordion_open');
        answerDiv.stop().slideDown(500);
      }
    });


    //hero_question_box
    $('.hero_question_heading').click(function () {
      var questionDiv = $(this);
      var answerDiv = $(this).next('.hero_question_content');
      var idx = $('.hero_question_content').index(answerDiv);

      $('.hero_question_content').each(function (index, ansDiv) {
        if (index != idx && $(ansDiv).is(':visible')) {
          $(ansDiv).slideUp(500, function () {
            $(ansDiv).prev('.hero_question_heading').removeClass('hero_question_heading_open');
          });
        }
      });

      if (answerDiv.is(':visible')) {
        answerDiv.stop().slideUp(500, function () {
          questionDiv.removeClass('hero_question_heading_open');
        });
      } else {
        questionDiv.addClass('hero_question_heading_open');
        answerDiv.stop().slideDown(500);
      }
    });







 $(document).ready(function() {

  function updateCartDrawer() {
  const cartUrl = `${window.Shopify.routes.root}cart?section_id=cart-drawer`;

  fetch(cartUrl)
    .then((res) => res.text())
    .then((html) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      // Update the cart drawer
      const newCartDrawer = tempDiv.querySelector('cart-drawer');
      if (newCartDrawer) {
        const existingCartDrawer = document.querySelector('cart-drawer');
        if (existingCartDrawer) {
          existingCartDrawer.replaceWith(newCartDrawer);
        } else {
          document.body.appendChild(newCartDrawer);
        }
        newCartDrawer.classList.add('animate', 'active');
        document.body.classList.add('cart-drawer-open');
      }

      // Update the cart count bubble
      const newCountBubble = tempDiv.querySelector('#cart-count-bubble');
      const existingCountBubble = document.querySelector('#cart-count-bubble');
      if (newCountBubble && existingCountBubble) {
        existingCountBubble.textContent = newCountBubble.textContent;
      }
    })
    .catch((err) => console.error("Cart fetch error:", err));
}







  let qty_lp = parseInt($(".butOption_row.active").attr("data-option")); // default quantity

  let offer_price = $(".butOption_row.active").attr("offer-price");

  let total_price =  $(".butOption_row.active").attr("total-price");

  $(".btn_price .btn_regular").html(total_price);
   $(".btn_price .btn_offer_price").html(offer_price);

  // Select package and update quantity
  $('.butOption_row').click(function() {
    

    offer_price = $(this).attr("offer-price");
    total_price =  $(this).attr("total-price");
  $(".btn_price .btn_regular").html(total_price);
   $(".btn_price .btn_offer_price").html(offer_price);
    $('.butOption_row').removeClass('active');
    $(this).addClass('active');
    $(this).find('input[type="radio"]').prop('checked', true);

    qty_lp = parseInt($(this).data('option')) || 1; // update quantity

    console.log(qty_lp)
  });

  // Add to cart
  $('.common_button.atc').click(function(e) {
    e.preventDefault();
    const variantId = $('#selectedVariantId').val();

    if (!variantId) return;

    $.post('/cart/add.js', {
      items: [{ id: variantId, quantity: qty_lp }]
    }, function(cart) {
      updateCartDrawer();
      console.log('Added to cart:', cart);
    }, 'json').fail(function(err) {
      console.error('Cart error:', err);
    });
  });
});








   $(document).ready(function () {


      var numSlick = 0;
      $('.hero_image_slider').each(function () {
        numSlick++;
        $(this)
          .addClass('slider-' + numSlick)
          .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            autoplay: false,
            autoplaySpeed: 11000,
            dots: false,
            asNavFor: '.hero_thumb_slider.slider-' + numSlick,
          });
      });

      numSlick = 0;
      $('.hero_thumb_slider').each(function () {
        numSlick++;
        $(this)
          .addClass('slider-' + numSlick)
          .slick({
            vertical: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.hero_image_slider.slider-' + numSlick,
            dots: false,
            focusOnSelect: true,
            arrows: false,
            adaptiveHeight: true,
            infinite: true,
          });
      });

      $('.petOwner_review_slider').slick({
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 700,
        infinite: true,
        autoplaySpeed: 4000,
        variableWidth: true,
        centerMode: false,
        arrows: false,
      });

      $('.butOption_row').click(function (e) {
        $(this).closest('.package_buyBox').find('.butOption_row').removeClass('active');
        $(this).addClass('active');
        $(this).find("input[type='radio']").prop('checked', true);
      });

            const packages = document.body.classList.contains('novapaw-lp-new-v2')
  ? {
      1: { regular: null, offer: '$49.50<small>/per pad</small>' },
      2: { regular: null, offer: '$24.75<small>/per pad</small>' },
      3: { regular: null, offer: '$33.00<small>/per pad</small>' },
    }
  : {
      1: { regular: null, offer: '$50' },
      2: { regular: '$297', offer: '$149' },
      3: { regular: '$149', offer: '$99' },
    };

          const rows = document.querySelectorAll('.butOption_row');
          const btnRegular = document.getElementById('btnRegular');
          const btnOffer = document.getElementById('btnOffer');

          let qty_lp = parseInt(document.querySelector('.butOption_row.active')?.dataset.option) || 1;
          function selectPackage(optionNum) {
            // Remove active from all
            rows.forEach((r) => r.classList.remove('active'));

            // Select the row by data-option
            const selectedRow = Array.from(rows).find(r => parseInt(r.dataset.option) === optionNum);
            if (!selectedRow) return;

            selectedRow.classList.add('active');
            selectedRow.querySelector("input[type='radio']").checked = true;

            // Update qty for cart
            qty_lp = parseInt(selectedRow.dataset.option) || 1;

            // Update price display
            const pkg = packages[optionNum];
            if (pkg.regular) {
              btnRegular.textContent = pkg.regular;
              btnRegular.style.display = '';
            } else {
              btnRegular.style.display = 'none';
            }
            btnOffer.textContent = pkg.offer;
          }
      // Add click listener to each row
      rows.forEach((row) => {
        row.addEventListener('click', () => {
          const opt = parseInt(row.dataset.option);
          selectPackage(opt);
        });
      });

    //Box_TIMER
    let totalSeconds = 2 * 60 * 60; // 2 hours

    function updateTimer() {
      let hours = Math.floor(totalSeconds / 3600);
      let minutes = Math.floor((totalSeconds % 3600) / 60);
      let seconds = totalSeconds % 60;

      document.getElementById('hours').textContent = String(hours).padStart(2, '0');
      document.getElementById('minutes').textContent = String(minutes).padStart(2, '0');
      document.getElementById('seconds').textContent = String(seconds).padStart(2, '0');

      if (totalSeconds > 0) {
        totalSeconds--;
      } else {
        clearInterval(timerInterval);
      }
    }

    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);

    });


  
  
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.common_button');
  if (!btn) return;

  const href = btn.getAttribute('href') || '';
  if (!href.includes('#')) return; // no # in href → leave the button alone

  e.preventDefault();

  const target = document.querySelector('#package_box_bundle');
  if (target) {
    const offset = 130; // adjust for header height
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
});

function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height();
	
	var elemTop = $(elem).offset().top;
	var elemBottom = elemTop + $(elem).height();
	
	return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
	}

$(document).scroll(function() {
		
	if ($(this).scrollTop() > 110){
		$('.fixed_header_bar').addClass('fixed_nav');
	}else{
		$('.fixed_header_bar').removeClass('fixed_nav');
	}
	
	//bottom fixed button
	var winscroll2 = $(window).scrollTop()
	var scrlbtn2 = $('.sticky_btn_show').offset().top + 100;
	
	
	if (winscroll2 > scrlbtn2 ){
		$('#call-btn').show();
	}else{
		$('#call-btn').hide();
	}
	
	var $elem = $('.footer');
	var $window = $(window);

	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();

	var elemTop = $elem.offset().top;
	var elemBottom = elemTop + $elem.height();

	if (elemTop >= (docViewBottom + 20) || (elemTop + $('#call-btn').height()) >= (docViewBottom + 104)) {
		$('#call-btn').css('position', 'fixed');
	} else {
		$('#call-btn').css({'position' : 'relative'});
	}


});